<script setup>
import Header from './Header.vue'
import {CheckCircleIcon, XCircleIcon} from '@heroicons/vue/24/solid'

</script>
<template>
<Header />
<div class="container mx-auto mb-8 px-2 lg:px-0 lg:w-1/2 flex flex-col gap-y-8">
    <h1 class="text-4xl text-center font-bold mt-16">
        Thank you!
    </h1>
    <p class="font-light text-xl my-4">
        Once again thank you for your donation! You made our day by showing us
        your appreciation and helping us host this wonderful platform. One secret
        perk that you get as a donator is a little shoutout in the post game
        screen.
    </p>
    <router-link :to="{'name': 'home'}">Home</router-link>
</div>

</template>

<style scoped>
</style>



